export default class DocumentType {
  documentTypeId?: number | null;
  name?: string | null;
  ageCategory?: string | null;
  sequence?: number | null;

  public constructor(params: DocumentType = {} as DocumentType) {
    let {
      documentTypeId = 0,
      name = "",
      ageCategory = "",
      sequence = null,
    } = params;
    this.documentTypeId = documentTypeId;
    this.name = name;
    this.ageCategory = ageCategory;
    this.sequence = sequence;
  }
}
